import { render, staticRenderFns } from "./TransferNoteModal.vue?vue&type=template&id=176a44fa&scoped=true"
import script from "./TransferNoteModal.vue?vue&type=script&lang=js"
export * from "./TransferNoteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176a44fa",
  null
  
)

export default component.exports